import React from "react";
import { newsletter } from "../data";

const Newsletter = () => {
	return (
		<section className="py-16 bg-yellow-500">
			<div className="container mx-auto px-4 text-center">
				<h2 className="text-3xl font-bold text-blue-900 mb-2">{newsletter.title}</h2>
				<p className="text-blue-800 mb-6">{newsletter.subtitle}</p>
				<form className="max-w-md mx-auto flex flex-col sm:flex-row gap-3">
					<input
						type="email"
						placeholder={newsletter.placeholder}
						className="flex-1 px-4 py-3 rounded-full text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-900"
					/>
					<button className="bg-blue-900 hover:bg-blue-800 text-white px-6 py-3 rounded-full font-semibold transition">
						{newsletter.buttonText}
					</button>
				</form>
			</div>
		</section>
	);
};

export default Newsletter;